import { useEffect, useMemo, useRef } from 'react';

const SANDBOX = 'allow-scripts';

export function CustomWidget({ fields }: { fields: Record<string, unknown> }) {
  const html = String(fields.html ?? '');
  const css = String(fields.css ?? '');
  const js = String(fields.js ?? '');
  const ref = useRef<HTMLIFrameElement | null>(null);

  const srcDoc = useMemo(
    () =>
      `<!doctype html><html><head><meta charset="utf-8"><style>html,body{margin:0;padding:0;width:100%;height:100%;background:transparent;color:white;font-family:system-ui}${css}</style></head><body>${html}<script>(function(){try{${js}}catch(e){console.error(e)}})();</script></body></html>`,
    [html, css, js],
  );

  useEffect(() => {
    if (ref.current) ref.current.srcdoc = srcDoc;
  }, [srcDoc]);

  return (
    <iframe
      ref={ref}
      sandbox={SANDBOX}
      style={{ width: '100%', height: '100%', border: 0, background: 'transparent' }}
      title="custom-widget"
    />
  );
}
